import types from './types';
import {fetchElementsPaginated, fetchElement, submitElement, deleteElement} from './common';

const apiUrl = '/api/posts';

export function submitPost(values) {
    return submitElement(apiUrl, values, types.SUBMIT_POST);
}
export function fetchPost(itemId) {
    return fetchElement(apiUrl, itemId, types.LOAD_POST);
}

export function fetchPostsPaginated(page = 0, size = 10) {
    return fetchElementsPaginated(`${apiUrl}/paginated`, page, size, types.LOAD_POSTS_PAGINATED);
}
export function fetchPostBySlug(slug) {
    return fetchElement(`${apiUrl}/slug`, slug, types.LOAD_POST);

}

export function deletePost(post) {
    return deleteElement(apiUrl, post.id, types.DELETE_POST);
}



// WEBPACK FOOTER //
// ./src/js/actions/post.js